import {
  baseUniDriverFactory,
  findByHook,
} from '../utils/test-utils/unidriver';
import type { UniDriver } from '@wix/unidriver-core';

import { DATA_HOOK } from './InputShell.constants';

export const inputShellDriverFactory = (base: UniDriver) => {
  return {
    ...baseUniDriverFactory(base),
    /**
     * Returns the tag name of the HTML element
     * @returns {Promise<string>}
     */
    getTagName: async (): Promise<string> =>
      (await base.prop('tagName')).toLowerCase(),
    /**
     * Returns true if dropdown arrow is displayed
     */
    hasMenuArrow: async (): Promise<boolean> => {
      const component = findByHook(base, DATA_HOOK.menuArrow);
      return component.exists();
    },
    isDisabled: async () => (await base.prop('disabled')) === true,
  };
};

export type InputShellUniDriver = ReturnType<typeof inputShellDriverFactory>;
